export default __webpack_public_path__ + "static/venture-5650d20fbfa680bbcf8c9477456f4377.png";